import "./styles.scss";
import BarMenu from "../BarMenu";
import Section from "./section";

export default function DashBoard() {

    return (
        <div id="DashBoard">
            <BarMenu />
            <section className="dashboard-section">
               <Section /> 
            </section>
        </div>
    );
}